﻿﻿import axios from 'axios';
import $ from 'jquery'
import store from '../vuex/store.js'
import {DataInit} from './dataInit'

const errorCode = {
    notoken: 403
};

const trim = function(obj){
    if(!obj){
        return obj;
    }
    let type = typeof(obj);
    if(type.toString() == 'string'){
        obj = $.trim(obj);
    } else if(type.toString() == 'array'){
        for(let index in obj){
            obj[index] = trim(obj[index]);
        }
    } else if(type.toString() == 'object'){
        for(let key in obj){
            obj[key] = trim(obj[key]);
        }
    }
    return obj;
};

/**
 * 异步
 *
 * @method send
 * */
let send = function (method, url, params, urlParams, notTrim) {
    if (!params) {
        params = {}
    } else if(!notTrim) {
        params = trim(params);
    }
    let promise = new Promise(function (resolve, reject) {
        $.ajax({
            url: url,
            type: method,
            data: params,
            cache: false,
            async: false,
            headers: {
                'token': JSON.parse(sessionStorage.getItem('user')).token,
            },
            params: urlParams,
            success: function (response) {
                resolve(response);
                // // 判断是否有属性IsSuccess，没有说明请求实际是失败的
                // if (!response.hasOwnProperty('IsSuccess')) {
                //     reject(response)
                // }
                //
                // // 判断服务器是否处理成功
                // if (response.IsSuccess) {
                //     // 返回content对象
                //     resolve(response.Content)
                // } else {
                //     // 判断是否是token失效错误
                //     if (!!response.ErrorCode && response.ErrorCode === errorCode.notoken) {
                //         // TODO 弹出token失效提示，并返回登录界面
                //         // reject(response.Msg)
                //     } else {
                //         // 返回错误信息
                //         reject(response.Msg)
                //     }
                // }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                // http请求失败，返回错误信息
                reject(errorThrown)
            }
        })
    });
    return promise;
};

/**
 * 同步
 *
 * @method sendSync
 * */
let sendSync = function(method, url, params, urlParams){
    if (!params) {
        params = {}
    }
    let promise = new Promise(function (resolve, reject) {
        $.ajax({
            url: url,
            type: method,
            data: params,
            dataType: "json",
            cache: false,
            async: false,
            headers: {
                'uuToken': store.state.uuToken,
                'UID': store.state.UID
            },
            params: urlParams,
            success: function (response) {
                // 判断是否有属性IsSuccess，没有说明请求实际是失败的
                if (!response.hasOwnProperty('IsSuccess')) {
                    reject(response)
                }

                // 判断服务器是否处理成功
                if (response.IsSuccess) {
                    // 返回content对象
                    resolve(response.Content)
                } else {
                    // 判断是否是token失效错误
                    if (!!response.ErrorCode && response.ErrorCode === errorCode.notoken) {
                        // TODO 弹出token失效提示，并返回登录界面
                        // reject(response.Msg)
                    } else {
                        // 返回错误信息
                        reject(response.Msg)
                    }
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                // http请求失败，返回错误信息
                reject(textStatus)
            }
        })
    });
    return promise
};

const uploadFile = function(url, file, params){
    let formData = new FormData();
    formData.append('file',file);
    return  axios({
        url: url,
        method: 'post',
        params: params,
        data: formData,
        responseType: 'json'
    })
    .then(res => DataInit(res.data))
    .catch(err => {
        if(typeof(err) == "string"){
            return Promise.reject(err)
        }else{
            return Promise.reject('Network Error');
        }
    });
};

const getJson = function(url) {
    $.ajaxSettings.async = false;
    let json = null;
    $.getJSON(url, {}, function(data) {
        json = data
    });
    $.ajaxSettings.async = true;
    return json;
};

const post = function (url, params, urlParams, notTrim) {
    return send('POST', url, params, urlParams, notTrim)
};

const get = function (url, params, urlParams, notTrim) {
    return send('GET', url, params, urlParams, notTrim)
};

const postSync = function (url, params, urlParams) {
    return sendSync('POST', url, params, urlParams)
};

const getSync = function (url, params, urlParams) {
    return sendSync('GET', url, params, urlParams)
};

export default {
    post,
    get,
    send,
    getJson,
    getSync,
    postSync,
    sendSync,
    uploadFile
}


// WEBPACK FOOTER //
// ./src/api/MyHttp.js